import type { ResourceConfig } from "../types";

export const attendanceConfig = {
  displayName: "考勤",
  category: "attendance",
  permissions: {
    "read:own": {
      label: "查看自己的考勤",
      description: "可以查看自己的考勤记录和统计数据",
    },
    "read:all": {
      label: "查看所有考勤",
      description: "可以查看所有教练的考勤记录",
    },
    "write:own": {
      label: "管理自己的考勤绑定",
      description: "可以绑定/解绑自己的飞书账号",
    },
    "write:all": {
      label: "管理考勤",
      description: "可以手动录入/修改任何教练的考勤记录",
    },
    "request:own": {
      label: "提交考勤申请",
      description: "可以提交自己的请假和补卡申请",
    },
    "request:review:assigned": {
      label: "审批负责教练的考勤申请",
      description: "可以审批 managerStaffId 指向自己的教练申请",
    },
    "request:review:all": {
      label: "审批所有考勤申请",
      description: "可以审批和撤销所有教练的考勤申请",
    },
    "report:read": {
      label: "查看考勤月报",
      description: "可以查看 HR 考勤月报",
    },
  },
} satisfies ResourceConfig;
